import { computed, Directive, HostBinding, input } from '@angular/core'

@Directive({
  selector: '[datoImage]',
  // It's nice not to have to import since it'll be everywhere
  standalone: false,
})
export class DatoImageDirective {
  /**
   * The source received from "Copy URL" on the asset in DatoCMS
   */
  protected src = input.required<string>()
  /**
   * Corresponds to the "w" param in imgix. Basically the width we fetch the image at.
   */
  protected imgixWidth = input.required<number>()
  protected processedSrc = computed(() => {
    const src = this.src()

    // SVGs should not be processed
    if (src.toLowerCase().endsWith('.svg')) {
      return src
    }

    const url = this.toURLOrUndefined(src)

    if (!url) {
      return src
    }

    const { searchParams } = url

    const existingAutoParam = searchParams.get('auto')
    // Consumer can override auto if they'd like. One needs to know what one is doing to get to that point.
    if (!existingAutoParam) {
      searchParams.set('auto', 'format')
    } else if (!existingAutoParam.includes('format')) {
      searchParams.set('auto', `${existingAutoParam},format`)
    }

    const existingWidthParam = searchParams.get('w')
    if (!existingWidthParam) {
      searchParams.set('w', this.imgixWidth().toString())
    }

    const existingQualityParam = searchParams.get('q')
    if (!existingQualityParam) {
      searchParams.set('q', '80')
    }

    return url.toString()
  })

  @HostBinding('src')
  get outputSrc(): string {
    return this.processedSrc()
  }

  private toURLOrUndefined(href: string | undefined): URL | undefined {
    if (!href) return

    try {
      return new URL(href)
    } catch {
      return
    }
  }
}
